import * as t from 'io-ts';
var OptionalString = t.union([t["null"], t.string]);
var Member = t.type({
  uuid: t.string,
  name: t.string,
  email: t.string,
  image: OptionalString,
  title: OptionalString,
  company: OptionalString
});
export var Members = t.array(Member);